import * as React from "react";

const s = require("./Title.scss");

interface ITitleProps {};

interface ITitleState {};

class Title extends React.Component<ITitleProps, ITitleState> {
    public render(): JSX.Element {
        return (
            <h2 className={s.title}>{this.props.children}</h2>
        );
    }
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/Header/Title/index.tsx